import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[QuoteStatus SetFilter] Action',
  ResetFilter: '[QuoteStatus ResetFilter] Action',
}

const initialQuoteStatusState: IQuoteStatusState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IQuoteStatusState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-QuoteStatus', whitelist: ['filter']},
  (
    state: IQuoteStatusState = initialQuoteStatusState,
    action: ActionWithPayload<IQuoteStatusState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialQuoteStatusState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
